import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin } from 'lucide-react';

interface NeedAddressModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function NeedAddressModal({ isOpen, onClose }: NeedAddressModalProps) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div
        className="relative w-full max-w-md rounded-2xl border border-border bg-card text-card-foreground shadow-2xl p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center mb-4">
          <div className="rounded-full bg-primary/15 p-4">
            <MapPin className="w-10 h-10 text-primary" />
          </div>
        </div>
        <h2 className="text-xl font-bold text-center mb-2">Add a delivery address</h2>
        <p className="text-sm text-muted-foreground text-center mb-6">
          We need a saved address before you can place an order. Add one now — it only takes a minute.
        </p>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-3 rounded-xl border border-border hover:bg-muted transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              onClose();
              navigate('/addresses', { state: { fromCheckout: true } });
            }}
            className="px-4 py-3 rounded-xl bg-primary text-primary-foreground font-semibold hover:opacity-90 transition-opacity"
          >
            Manage addresses
          </button>
        </div>
      </div>
    </div>
  );
}
